import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { Modal } from 'main/ui'
import { useTranslation } from 'react-i18next'
import Content from './Content'
import { IWithExternalSchoolId, IWithSchoolId, Step, StepName } from './types'
import { title } from './util'

interface IPropsBase {
  onComplete?: (callbackData?: {}) => void
  onRequestClose: () => void
}

type Props = IPropsBase & (IWithSchoolId | IWithExternalSchoolId)

export default function ContactSchoolModal(props: Props) {
  const [step, setStep] = React.useState<Step | null>(null)
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Modal
      googleOptimize={googleOptimize()}
      title={step ? title(step, t) : ''}
      onRequestClose={props.onRequestClose}
    >
      <Content step={step} onChangeStep={setStep} onDone={props.onRequestClose} {...props} />
    </Modal>
  )

  function googleOptimize() {
    return step && step.__stepname === StepName.SignUp ? { title: 'contactSchoolSignUpTitle' } : {}
  }
}
